import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getFullRequirementsStructure = ({
  requirementUUID,
  planSchoolId,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/cp-requirements/requirements/${requirementUUID}/get-all-requirement-tree?k12_school_id=${planSchoolId}`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateRequirementNodeCourses = ({
  requirementUUID,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/cp-requirements/requirements/${requirementUUID}/update-courses/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const retrieveTopLevelRequirement = ({
  requirementUUID,
  version = 'v1',
  params = {},
}) =>
  client
    .request({
      url: `${version}/cp-requirements/top-level-requirement/${requirementUUID}`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
